import { Award, Users, Globe, Truck } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }} data-testid="about-title">
            About Blue Oyster
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Bringing the freshness of the ocean straight to your table
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38"
              alt="Our Company"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Our Story
            </h2>
            <p className="text-gray-600 mb-4">
              Blue Oyster represents over 10 years of experience in supplying premium seafood. We work directly with the best producers from Russia, Asia, Africa, and Europe.
            </p>
            <p className="text-gray-600">
              Our mission is to make exquisite seafood accessible to everyone while maintaining the highest quality and freshness.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-20">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-sky-50 to-blue-50">
            <div className="w-16 h-16 bg-sky-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold mb-2">10+</h3>
            <p className="text-gray-600">Лет на рынке</p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-cyan-50 to-teal-50">
            <div className="w-16 h-16 bg-cyan-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold mb-2">5000+</h3>
            <p className="text-gray-600">Довольных клиентов</p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Globe className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold mb-2">20+</h3>
            <p className="text-gray-600">Стран-поставщиков</p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-purple-50 to-pink-50">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Truck className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-3xl font-bold mb-2">100%</h3>
            <p className="text-gray-600">Свежие продукты</p>
          </div>
        </div>

        <div className="bg-gradient-to-r from-sky-600 to-cyan-600 rounded-2xl p-12 text-white text-center">
          <h2 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Наши преимущества
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div>
              <h3 className="text-xl font-bold mb-3">Качество</h3>
              <p className="text-white/90">Только проверенные поставщики и сертифицированные продукты</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-3">Доставка</h3>
              <p className="text-white/90">Сохраняем холодовую цепь при доставке в термобоксах</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-3">Поддержка</h3>
              <p className="text-white/90">Консультируем по выбору и приготовлению</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}